import { createContext } from 'react';
import { AskContextValue } from './types';

export const AskContext = createContext<AskContextValue | undefined>(undefined);
